export var ENTITY = "preference";
export var REDUCER_KEY = "PREFERENCE_V2";
export var BASE_PATH_ENTITY = "preference";
// The per-user store hangs off the user controller rather than the `preference` one the
// rest of this module targets. `me` is resolved from the access token server-side.
export var USER_PREFERENCES_PATH = "/users/me/preferences";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
